import React from "react";

import "../styles/button.css";

interface ButtonProps {
  onClick: () => void;
  type: "primary" | "secondary";
  children?: React.ReactNode;
  styles?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  type,
  children,
  styles,
  disabled
}) => {
  return (
    <button
      className={`button button-${type} ${styles}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
